<template>
  <a-drawer
:maskClosable="false"
width="35%"
:label-col="4"
:wrapper-col="14"
:visible="open"
@close="onClose"
:destroyOnClose="true">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="属性名称" prop="name">
        <a-input v-model="form.name" placeholder="请输入" :maxLength="50" />
      </a-form-model-item>
      <a-form-model-item label="积分倍数(1等于积分100%,2等于积分200%)" prop="multiple">
        <a-input
          v-model="form.multiple"
          placeholder="请输入"
          :maxLength="4"
        />
      </a-form-model-item>
      <!-- <a-form-model-item label="压降数值" prop="pressureDropValue">
        <a-input
          v-model="form.pressureDropValue"
          placeholder="请输入"
          oninput="value=value.replace(/[^\d]/g,'')"
          :maxLength="50"
        />
      </a-form-model-item> -->
      <a-form-model-item label="备注	" prop="remark">
        <a-input v-model="form.remark" placeholder="请输入" :maxLength="50" />
      </a-form-model-item>
      <a-form-model-item label="排序" prop="sort">
        <a-input v-model="form.sort" placeholder="请输入" :maxLength="20" oninput="value=value.replace(/[^\d]/g,'')" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm"> 保存 </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>
<script>
import { getObj, addObj, putObj } from '@/api/pressure/attribute'
export default {
  name: 'CreateForm',
  props: {
    statusOptions: {
      type: Array,
      required: true,
    },
    modelId: {
      type: [String, Number],
    },
    modelCaliberId: {
      type: [String, Number],
    },
  },
  components: {},
  data() {
    const reg = /^(0|[1-9]?\d)(\.\d)?$/
    const validateYa = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入积分倍数'))
      } else if (!reg.test(value)) {
        callback(new Error('请输入正确的积分倍数(0-99)最多1位小数'))
      } else {
        callback()
      }
    }
    return {
      submitLoading: false,
      data: [],
      formTitle: '',
      inputValue: '',
      inputValues: '',
      // 表单参数
      form: {
        id: undefined,
        modelCaliberId: undefined,
        modelId: undefined,
        multiple: undefined,
        name: undefined,
        remark: undefined,
        sort: 99,
      },
      isShow: false,
      tags: [],
      tagslist: [],
      open: false,
      hour: [],
      hours: [],
      minute: [],
      minutes: [],
      inputVisible: false,
      inputVisibles: false,
      rules: {
        // pressureDropValue: [
        //   { required: true, message: '请输入压降数值', trigger: 'blur' },
        //   { validator: validateYa, trigger: ['blur', 'change'] },
        // ],
        name: [{ required: true, message: '请输入属性名称', trigger: 'blur' }],
        sort: [{ required: true, message: '请输入排序', trigger: 'blur' }],
        multiple: [{ required: true, message: '请输入积分倍数', trigger: 'blur' },
        { validator: validateYa, trigger: ['blur', 'change'] },
        ],
      },
    }
  },
  filters: {},
  created() {
    console.log('statusOptions 显示隐藏', this.statusOptions)
  },
  computed: {},
  watch: {},
  methods: {
    onClose() {
       const that = this
      this.$confirm({
        title: '是否确认关闭清空数据',
        onOk() {
          console.log(that.open, 'openopen')
          that.open = false
        },
        onCancel() {},
      })
    },
    // 取消按钮
    cancel() {
       this.onClose()
      this.reset()
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset()
      this.open = true
      this.formTitle = '添加属性'
    },
    // 表单重置
    reset() {
      this.form = {
        id: undefined,
        modelCaliberId: undefined,
        modelId: undefined,
        multiple: undefined,
        name: undefined,
        remark: undefined,
        sort: 99,
      }
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      console.log(row, '顶顶顶顶')
      this.form = JSON.parse(JSON.stringify(row))
      this.formTitle = '修改属性'
      this.open = true
    },
    /** 提交按钮 */
    submitForm: function () {
      console.log(this.form, '对对对对对对')

       this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined) {
            putObj(this.form)
              .then((response) => {
                this.$message.success('修改成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
 this.showLoading = false

              })
          } else {
            this.form.modelId = this.modelId
            this.form.modelCaliberId = this.modelCaliberId
            addObj(this.form)
              .then((response) => {
                this.$message.success('新增成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
 this.showLoading = false

              })
          }
        } else {
          return false
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
.model_t {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  input {
    width: 30%;
    margin-right: 10px;
  }
}
</style>
